// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"dbca01e0","37":"4cd97e9d","125":"855ef9f2","311":"90e06635","331":"e9e37e6d","385":"ae981896","431":"74b43cad","561":"cce133f8","797":"c7b3b4a9","824":"503209e8"}[chunkId] + ".chunk.js";
};